import React from "react";

/**
 * Legacy wrapper for public pages.
 *
 * IMPORTANT:
 * The application now uses the unified layout (AppHeader + TopNav + Footer)
 * also for public / login pages. Therefore this component must NOT render its
 * own header/title (otherwise it duplicates layout and hides the real header).
 *
 * Keeping the component to minimize changes in pages that still import it.
 */
const PublicPage = ({ children }) => {
  return <>{children}</>;
};

export default PublicPage;
